import React from 'react';

function Footer() {
  return (
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '300px',
        padding: '4rem 10%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#050505',
        zIndex: 0,
        borderTop: '1px solid rgba(255,255,255,0.1)',
        textAlign: 'center',
        color: '#666',
      }}
    >
      <h2 style={{ marginBottom: '0' }}>CloudNest Agency</h2>
      <div className="social-links" style={{ marginTop: '1.5rem' }}>
        <a href="https://github.com" target="_blank" rel="noopener noreferrer" style={{ color: '#666', margin: '0 1rem', fontSize: '1.5rem', transition: 'color 0.3s' }}
          onMouseEnter={e => e.currentTarget.style.color = '#00ffcc'}
          onMouseLeave={e => e.currentTarget.style.color = '#666'}>
          <i className="fa-brands fa-github" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={{ color: '#666', margin: '0 1rem', fontSize: '1.5rem', transition: 'color 0.3s' }}
          onMouseEnter={e => e.currentTarget.style.color = '#00ffcc'}
          onMouseLeave={e => e.currentTarget.style.color = '#666'}>
          <i className="fa-brands fa-twitter" />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: '#666', margin: '0 1rem', fontSize: '1.5rem', transition: 'color 0.3s' }}
          onMouseEnter={e => e.currentTarget.style.color = '#00ffcc'}
          onMouseLeave={e => e.currentTarget.style.color = '#666'}>
          <i className="fa-brands fa-linkedin" />
        </a>
        <a href="https://dribbble.com" target="_blank" rel="noopener noreferrer" style={{ color: '#666', margin: '0 1rem', fontSize: '1.5rem', transition: 'color 0.3s' }}
          onMouseEnter={e => e.currentTarget.style.color = '#00ffcc'}
          onMouseLeave={e => e.currentTarget.style.color = '#666'}>
          <i className="fa-brands fa-dribbble" />
        </a>
      </div>
      <p style={{ marginTop: '2rem' }}>© 2026 CloudNest. All rights reserved.</p>
    </footer>
  );
}

export default Footer;

